// src/config/menu.js
// サイドバーメニューの定義と、ロール / 機能フラグでのフィルタリング。
//
// MENU 配列の各エントリは以下のフィールドを持つ:
//   to:       ルートパス
//   icon:     components/Icon.jsx のアイコン名（絵文字はOS毎に見た目が違うため廃止【2026-07-21】）
//   label:    表示名
//   roles:    表示するロール一覧 (必須)
//   feature:  オプション。指定するとユーザーの features 配列にこの値が無いと出さない
//             user.features が undefined or null の場合は「全機能ON」とみなす（後方互換）
//
// 通知 (/notifications) と アカウント設定 (/profile) は topbar から開く前提なので
// サイドバーには出さないが、ページタイトル解決のために HIDDEN_TOP_PAGES に登録しておく。

const MENU = [
  { to: '/',             icon: 'home', label: 'ダッシュボード',  roles: ['student','teacher','academic_staff','developer'] },
  { to: '/attendance',   icon: 'check-square', label: '出席確認',         roles: ['student'] },
  // 【2026-09-11】ビーコンの受付開始も同じ画面に置いたので「出席受付」に改名。
  //   パスは /otp のまま（ブックマークやスマホのタブが死なないように）。
  { to: '/otp',          icon: 'hash', label: '出席受付',         roles: ['teacher','developer'] },
  { to: '/live',         icon: 'radio', label: 'リアルタイム出席', roles: ['teacher','developer'] },
  // 【2026-09-04】出席記録・レポート出力・出席CSV取り込みは、どれも
  //   「授業を選んでから使う」画面だったので授業管理のサブページに統合した。
  //   /classes → 授業を開く → 左のサブメニューから辿る。
  // children を持つ項目は、その配下のページを開いているとき
  // サイドバー内に字下げしたサブメニューを出す（ConoHaのネットワーク配下と同じ形）
  // 授業を1つ開いていないと行き先が決まらないので、/classes/:classId 配下でのみ表示する
  { to: '/classes',      icon: 'book', label: '授業管理',         roles: ['teacher','developer'],
    children: [
      { section: 'schedule', label: '授業スケジュール' },
      // 受講者名簿は学生管理に統合した【2026-09-17】（/classes/:id/roster は学生管理へ転送）
      // 出席記録 = 集計 + レポート出力 + 出席CSV取り込み を1ページにまとめたもの
      { section: 'summary',  label: '出席記録' },
      // 出欠を直す専用のページ【2026-10-07】。学生からの申請・確認待ちの打刻もここ
      { section: 'edit',     label: '出欠の確認・修正' },
    ] },
  // 【2026-09-28】学生管理は教務だけのメニューにした。教員は授業から名簿を開く
  //   （/students?classId=… のリンクは教員もそのまま使える。ルートは閉じていない）
  { to: '/students',     icon: 'users', label: '学生管理',         roles: ['academic_staff','developer'] },
  // 教務向けの一括インポート（ユーザー一括登録・複数科目の名簿まとめ取り込み）は
  // 授業単位ではないので、教務のサイドバーには残す。
  { to: '/csv-import',   icon: 'folder', label: 'CSVインポート',    roles: ['academic_staff','developer'] },
  { to: '/academic',     icon: 'grad-cap', label: '教務管理',         roles: ['academic_staff','developer'] },
  // 【2026-09-17】変更履歴（/users-audit）は普段見ないので、サイドバーから外した。
  //   入口はアカウント設定の「その他」と、学生管理の下の小さなリンク。
  // 【2026-09-14】名簿の取り込み履歴。年度・学期は取り込み1回ぶんで持っているので、
  //   選び間違えたときの直し場所と、取り消しの入口をここに置く。
  // 【2026-09-30】学生からの出欠の訂正・公欠の申請。先生は担当の授業、教務は大学の授業。
  // 【2026-10-07】先生は授業管理の「出欠の確認・修正」にまとめたので、このメニューは教務だけ（/requests の URL は先生も使える）
  { to: '/requests',     icon: 'list', label: '出欠の確認',       roles: ['academic_staff','developer'] },
  { to: '/roster-imports', icon: 'folder', label: '名簿取り込み履歴', roles: ['teacher','academic_staff','developer'] },
  // 【2026-09-10】サーバーの安全確認。専門知識なしで状態を見て、
  //   ロックされたアカウントをその場で解除できる画面。
  //   設定値やディスク残量まで出るので、教務スタッフ以上に限定する。
  { to: '/security',     icon: 'shield', label: '安全確認',         roles: ['academic_staff','developer'] },
  // 【2026-09-17】終わった年度（学期）の締め・暗号化保管・消去。教務だけ。
  { to: '/data-retention', icon: 'archive', label: '年度の締め・保管', roles: ['academic_staff','developer'] },
  { to: '/app-download', icon: 'smartphone', label: 'アプリDL',         roles: ['student','teacher','academic_staff','developer'] }
];

// サイドバーには出さないが、直接URLで開いたときにページ名を出すためのもの
const HIDDEN_TOP_PAGES = [
  // 【2026-09-07】ICカードは今の運用で使っていないのでサイドバーから外した。
  //   ページとルートはそのまま残してあるので、使うときはここの1行を
  //   MENU 側へ戻せば元通りになる。
  { to: '/cards',         label: 'ICカード' },
  { to: '/class-summary', label: '出席記録' },
  { to: '/reports',       label: 'レポート出力' },
  { to: '/notifications', label: '通知' },
  { to: '/profile',       label: 'アカウント設定' },
  { to: '/users-audit',   label: '変更履歴' },
  // 教員は授業の名簿リンクから開く（サイドバーには出さない）【2026-09-28】
  { to: '/students',      label: '学生管理' }
];

// 下の階層のページ名（前方一致で引く）【2026-10-08】
const SUB_PAGES = [
  { to: '/classes', label: '授業管理' },
];

/**
 * サイドバーに出すメニュー項目を返す。
 * @param {{ role: string, features?: string[] }} user
 */
export function getMenuItems(user) {
  if (!user || !user.role) return [];
  return MENU.filter(it => {
    if (!it.roles.includes(user.role)) return false;
    // feature が指定されている場合、user.features が配列ならその値を含むことを要求
    // user.features が undefined / null の場合は「全機能ON」として通す（後方互換）
    if (it.feature && Array.isArray(user.features) && !user.features.includes(it.feature)) {
      return false;
    }
    return true;
  });
}

/**
 * 現在のパスに対応するページタイトルを返す。
 * 通知・プロフィールも含めて解決する。
 */
export function getPageLabel(pathname, user) {
  const all = [...getMenuItems(user), ...HIDDEN_TOP_PAGES, ...SUB_PAGES];
  const hit = all.find(it => it.to === pathname);
  if (hit) return hit.label;
  // 完全に一致しないとき（/classes/21/summary など）は、いちばん長く前が一致するもの【2026-10-08 レビュー】
  const p = String(pathname || '').replace(/\/+$/, '');
  const pre = all
    .filter(it => it.to && it.to !== '/' && p.startsWith(it.to.replace(/\/+$/, '') + '/'))
    .sort((a, b) => b.to.length - a.to.length)[0];
  return pre ? pre.label : '';
}
